import type {AccentStateButton} from '../types'
import type {WebTrackingResponse} from '../types/webState'

/**
 * Мок постоплатного сценария (CARGODEV-83069), присланный из бекенда «как есть».
 * Обрати внимание: в исходном ответе НЕТ поля accent_state_button — поэтому
 * кнопка «Оплатить» с ним не рендерится (debug=3).
 */
const rawPostpayState = {
  context: {
    present_as_completed: false,
    display_targets: ['multiorder'],
    role: 'recipient',
    promotion_banners_enabled: false,
    tracking_popup: {
      popup_settings: {
        page: 'DostavkaReturningPopUp',
        overrides: {
          path: '/urbanads/sdk',
          experiments:
            'market_madv_disable_filtering_by_probability=1;market_madv_disable_frequency_in_popup=1;market_madv_disable_read_pop_up_bigb_event_metainfo=1;market_madv_disable_read_bigb_reach_frequency=1;market_madv_disable_perks_filtering=1',
        },
        type: 'urban-ads',
      },
      show_policy: {
        cache_key: 'tracking_popup_780ca1e9-3f0a-4b9d-9676-246077fd6189',
        max_show_count: 1,
        policy_lifetime: 'persistent',
        type: 'limited',
      },
    },
    ads_banner: {
      ads_banner_settings: {
        page: 'DostavkaTracking',
        overrides: {path: 'urbanads/sdk'},
        type: 'urban-ads',
      },
    },
  },
  summary: 'Можно забирать',
  description: 'Ждёт вас в пункте выдачи до 22 июля',
  icon_strategy: {
    image_tag: 'delivery_icon_smile_box_tracking',
    type: 'remote_image',
  },
  sorted_route_points: [
    {
      point_id: '0',
      visit_status: 'pending',
      uri: 'ymapsbm1://geo?ll=55.740123%2C37.62618',
      coordinates: [37.62618, 55.740123],
      full_text: '',
      short_text: '',
      area_description: '',
      pin: {
        title: 'Пункт выдачи',
        icon_tag: 'delivery_pvz_pin_tracking_market',
        type: 'bubble',
      },
      type: 'source',
    },
  ],
  active_route_points: [0],
  primary_actions: [
    {
      title: 'Играть',
      image_tag: 'delivery_market_game_ad',
      url: 'https://gaming.market.yandex.ru/?gameId=mark3&client=dostavka&platform=ios&hideCloseButton=1',
      should_authorize: true,
      metrica_label: 'Delivery.Tracking.Action.OpenGameUrl',
      type: 'open_universal_link',
    },
    {
      mode: 'recipient_postpay_info',
      card_mode: {
        is_slideable: false,
        skeleton_height: 300,
        type: 'wrap_content_height',
      },
      top_button: 'close',
      client_state: {},
      is_cache_state: false,
      title: 'Важное про оплату ',
      image_tag: 'delivery_InfoOutline',
      metrica_label: 'Delivery.Tracking.Action.OpenForm.RecipientPostpayInfo',
      type: 'open_form',
    },
  ],
  secondary_actions: [
    {
      title: 'Поделиться ссылкой',
      sharing_url: 'https://logistics-frontend.taxi.tst.yandex.ru/route/780ca1e9-3f0a-4b9d-9676-246077fd6189',
      type: 'share',
    },
    {
      title: 'Помощь',
      messenger_params: {
        messenger_header: {
          title: 'Доставка',
          subtitle: 'Задайте вопрос',
          chat_icon: 'delivery_messenger_chat_icon',
        },
        chat_request: {
          bot_id: '9f720c06-dd11-91de-53d8-9b71c58e626e',
          type: 'chat_with_bot',
        },
        chat_meta: {
          locale: 'ru',
          order_id: 'fab33c6c082f46fa816c8a430d885d88-udp',
        },
      },
      image_tag: 'delivery_chat_bot_action_icon',
      metrica_label: 'Delivery.Tracking.Action.OpenChat',
      type: 'open_chat',
    },
  ],
  content_sections: [
    {
      id: '3a2774d28cbb42abb2c0a9367e5d9af1',
      items: [
        {
          id: 'ba327f4b14244a96a3a564abdfdaef7d',
          barcode_type: 'linear',
          barcode: {barcode: 'LO-3517414-51064', type: 'barcode_string'},
          subtitle: 'Штрихкод для получения',
          trail_image_tag: 'delivery_barcode_open',
          orientation: 'horizontal',
          action: {
            action: {
              content_sections: [
                {
                  id: 'c9f3d4f7d3f946318660e58168e55163',
                  items: [
                    {
                      id: '23bcb4bf8cf149aeb037a2248900dd1d',
                      title: {
                        text: 'Покажите штрихкод сотруднику пункта выдачи',
                        typography: 'body2',
                        color: 'TextMain',
                        max_lines: 2,
                      },
                      type: 'list_item',
                    },
                    {
                      id: 'f03b73973102401c8aa814ab1a5dc88b',
                      barcode_type: 'linear',
                      barcode: {barcode: 'LO-3517414-51064', type: 'barcode_string'},
                      orientation: 'vertical',
                      type: 'barcode',
                    },
                    {
                      id: '75f21e4fc8274f47b6f40c79d4a7a22d',
                      title: {text: 'LO-3517414', typography: 'body2', color: 'TextMain', max_lines: 2},
                      subtitle: {text: 'Номер заказа', typography: 'caption1', color: 'TextMinor', max_lines: 1},
                      trail_text: {text: '51064', typography: 'body2', color: 'TextMain', max_lines: 10},
                      trail_subtitle: {text: 'Код получения', typography: 'caption1', color: 'TextMinor', max_lines: 1},
                      type: 'list_item',
                    },
                  ],
                },
              ],
              maximize_screen_brightness: true,
              type: 'show_content_sections',
            },
            type: 'action-payload',
          },
          type: 'barcode',
        },
        {
          id: 'a6baf7f8564947f09d8d8d9be476ff77',
          title: {text: '51064', typography: 'body2', color: 'TextMain', max_lines: 1},
          subtitle: {text: 'Код выдачи', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          title_alignment: 'center',
          subtitle_alignment: 'center',
          type: 'text_widget',
        },
        {id: '', type: 'separator'},
        {
          id: '6d96e19c00de466a982d35354d8fcdc9',
          title: {text: 'Номер заказа', typography: 'body2', color: 'TextMain', max_lines: 1},
          trail_text: {text: 'LO-3517414', typography: 'body2', color: 'TextMain', max_lines: 1},
          lead_icon: {image_tag: 'delivery_order_number'},
          trail_payload: {
            buffer: 'LO-3517414',
            in_app_notification_text: 'Номер заказа скопирован',
            type: 'copy-payload',
          },
          type: 'list_item',
        },
      ],
    },
    {
      id: '2941ddd5a26a4841940027b1b0dc0593',
      items: [
        {
          id: 'eb0f2358d54f4de2a17421f0a88f7a6b',
          title: {text: 'Посылка', typography: 'body2', color: 'TextMain', max_lines: 1},
          subtitle: {text: '2 х 26 х 20 см', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          lead_icon: {image_tag: 'delivery_package'},
          type: 'list_item',
        },
        {id: '', type: 'separator'},
        {
          id: 'a98a45c0864b489c8d5a6848d419495a',
          title: {text: 'Доставка', typography: 'body2', color: 'TextMain', max_lines: 1},
          subtitle: {text: 'Итоговая стоимость', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          trail_text: {text: '199 ₽', typography: 'body2', color: 'TextMain', max_lines: 1},
          trail_subtitle: {text: 'К оплате', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          lead_icon: {image_tag: 'delivery_ndd_card_unpaid'},
          metrica_label: 'Delivery.Tracking.Item.PaymentInfo',
          type: 'list_item',
        },
        {
          id: 'a4e65caab8f647158e27d9274484e2cb',
          title: {text: 'Что входит в доставку', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          type: 'header',
        },
        {
          id: 'd9302c2ed12749878360921e507b82fc',
          title: {text: 'Доставка', typography: 'body2', color: 'TextMain', max_lines: 1},
          subtitle: {text: 'Базовая стоимость ', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          trail_text: {text: '99 ₽', typography: 'body2', color: 'TextMain', max_lines: 1},
          lead_icon: {image_tag: 'delivery_ndd_summary_base_cost'},
          type: 'list_item',
        },
        {
          id: '8d1f1f530ccb4781a5ae18eb369688e7',
          title: {text: 'Оплата получателем', typography: 'body2', color: 'TextMain', max_lines: 1},
          subtitle: {text: 'Плата за опцию', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          trail_text: {text: '100 ₽', typography: 'body2', color: 'TextMain', max_lines: 1},
          lead_icon: {image_tag: 'delivery_pay_on_delivery_online_payment'},
          type: 'list_item',
        },
        {
          id: '849abc88b7b0443f9f8dea655f0fe57c',
          title: {text: 'Пункт выдачи', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          type: 'header',
        },
        {
          id: '969891cc1b8048128ed0a5cda9a3a172',
          title: {text: '', typography: 'title1', color: '', max_lines: 0},
          subtitle: {
            text: 'Москва, улица Малая Ордынка, 5/6с2-3',
            typography: 'body2',
            color: 'TextMain',
            max_lines: 1,
          },
          lead_icon: {image_tag: 'delivery_point'},
          trail_payload: {
            buffer: 'Москва, улица Малая Ордынка, 5/6с2-3',
            in_app_notification_text: 'Адрес скопирован',
            type: 'copy-payload',
          },
          type: 'list_item',
        },
        {id: '24961889bbfb44bbb2d6919bfefcc570', type: 'separator'},
        {
          id: '2511ef09d78f4325809ec7ebf6296a20',
          title: {text: 'Отправитель', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          type: 'header',
        },
        {
          id: 'd60bda7f44544e07ac58f4eb723b8787',
          title: {text: 'Телефон для связи', typography: 'caption1', color: 'TextMinor', max_lines: 1},
          subtitle: {text: '+79250962805', typography: 'body2', color: 'TextMain', max_lines: 1, ignore_rtl: true},
          lead_icon: {image_tag: 'delivery_phone'},
          trail_payload: {
            buffer: '+79250962805',
            in_app_notification_text: 'Номер телефона скопирован',
            type: 'copy-payload',
          },
          metrica_label: 'Delivery.Tracking.Item.ContactPhone',
          type: 'list_item',
        },
      ],
    },
  ],
  meta: {},
  timeline: {
    horizontal: [
      {
        id: 'accepted',
        status: 'passed',
        image_tag: 'delivery_timeline_hourglass',
        image_tag_dark: 'delivery_timeline_hourglass',
      },
      {
        id: 'ready_for_pickup',
        status: 'passed',
        image_tag: 'delivery_timeline_pvz_indepot',
        image_tag_dark: 'delivery_timeline_pvz_indepot',
      },
      {
        id: 'delivered',
        status: 'pending',
        image_tag: 'delivery_timeline_pvz_finished',
        image_tag_dark: 'delivery_timeline_pvz_finished',
      },
    ],
    current_item_id: 'ready_for_pickup',
  },
}

/** Постоплатный мок «как есть» из бекенда — БЕЗ accent_state_button (debug=3). */
export const webStatePostpayMock = {
  state: rawPostpayState,
} as unknown as WebTrackingResponse

/**
 * Тот же мок, но с добавленной accent_state_button — как бекенд ДОЛЖЕН
 * присылать кнопку «Оплатить» для постоплаты (debug=4).
 */
const payAccentButton: AccentStateButton = {
  background_color: 'controlMain',
  title: 'Оплатить',
  title_color: 'textOnControl',
  subtitle: '199 ₽',
  action: {
    type: 'order-state-action',
    action: {
      type: 'open_universal_link',
      url: 'https://testing.eda.tst.yandex.ru/inplace/menu?uuid=3bd8f05c2b5b4e7bae794dcf97942930&order_type=cargo',
    },
  },
  metrica_label: 'Delivery.Tracking.Action.Pay',
} as unknown as AccentStateButton

/**
 * Кнопка оплаты «внизу» (pay-for-order, CARGODEV-74017) — приходит как
 * bottom_content_sections с item'ами spacer + action_button.
 */
const payForOrderBottomSections = [
  {
    id: '6686d7a1814049e18df79bcc294f0eaf',
    items: [
      {height: 8, type: 'spacer'},
      {
        type: 'action_button',
        title: {
          text: 'Оплатить · 199 ₽',
          color: 'ButtonTextMain',
          typography: 'body2',
          weight: 'medium',
          max_lines: 1,
        },
        action_payload: {
          type: 'action-payload',
          action: {
            type: 'open_universal_link',
            url: 'https://testing.eda.tst.yandex.ru/inplace/menu?uuid=3bd8f05c2b5b4e7bae794dcf97942930&order_type=cargo',
            should_authorize: false,
            title: '',
            image_tag: '',
          },
        },
        metrica_label: 'Delivery.Tracking.Action.PayForOrder',
      },
      {height: 8, type: 'spacer'},
    ],
  },
]

/**
 * Bubble с кнопкой «Узнать» (попап статусов) — сценарий CARGODEV-85875:
 * попап должен открываться поверх плавающей кнопки оплаты.
 * Структура по образцу web-state-auth.ts.
 */
const postpayTimelineBubble = {
  background: {
    alpha_day: 1,
    alpha_night: 1,
    color_day: 'f5f4f2',
    color_night: '302f2d',
  },
  button: {
    title: 'Узнать',
    action: {
      type: 'detail_timeline',
      title: 'Детали доставки',
      done_button: {
        text: 'Закрыть',
      },
      vertical: [
        {
          lead_title: '17 июня',
          lead_subtitle: '13:40',
          status: 'passed',
          title: 'Создан',
          title_color: {alpha_day: 1, alpha_night: 1, color_day: '21201f', color_night: 'e0deda'},
          subtitle_color: {alpha_day: 0.5, alpha_night: 0.5, color_day: '21201f', color_night: 'e0deda'},
        },
        {
          lead_title: '17 июня',
          lead_subtitle: '13:48',
          status: 'passed',
          title: 'Принят пунктом выдачи',
          subtitle: 'улица Малая Ордынка 5/6 стр2-3, Москва',
          title_color: {alpha_day: 1, alpha_night: 1, color_day: '21201f', color_night: 'e0deda'},
          subtitle_color: {alpha_day: 0.5, alpha_night: 0.5, color_day: '21201f', color_night: 'e0deda'},
        },
        {
          lead_title: '17 июня',
          lead_subtitle: '13:49',
          status: 'active',
          title: 'Ждёт вручения в пункте выдачи',
          subtitle: 'Срок хранения до 6 июля',
          title_color: {alpha_day: 1, alpha_night: 1, color_day: '21201f', color_night: 'e0deda'},
          subtitle_color: {alpha_day: 0.5, alpha_night: 0.5, color_day: '21201f', color_night: 'e0deda'},
        },
        {
          status: 'pending',
          title: 'Доставлен',
          title_color: {alpha_day: 0.5, alpha_night: 0.5, color_day: '21201f', color_night: 'e0deda'},
        },
      ],
    },
  },
  title: 'Заказ ждёт вас в пункте выдачи',
  lead_icon_tag: 'delivery_timeline_pvz_indepot',
}

export const webStatePostpayWithButtonMock = {
  state: {
    ...rawPostpayState,
    accent_state_button: payAccentButton,
    bottom_content_sections: payForOrderBottomSections,
    timeline: {
      ...rawPostpayState.timeline,
      bubble: postpayTimelineBubble,
    },
  },
} as unknown as WebTrackingResponse
